import React from "react";
import { useNavigate } from "react-router-dom";
import { masterSpareVariantTableColumnConfig } from "./masterSpareVariantColumnConfig";
import { Table } from "../../../../../component/table/Table";

export const MasterSpareVariantTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigate = (itemId) => {
  navigate(`/masters/spares/variants/${itemId}`);
};

  const columnDefs = masterSpareVariantTableColumnConfig(handleNavigate);

  return (
    <Table
      data={data}
      columns={columnDefs}
      mobileHiddenColumns={["price", "original_price"]}
    />
  );
};
